import axiosPost from "./axiosPost";

export const SFHotelUsuarioCheckoutDo = async (credentials, data) => {
    const body = {
        service: "SFHotelUsuarioCheckoutDo",
        params: {
            SFHabitacionHuespedId: data.SFHabitacionHuespedId,
        },
    };

    const result = await axiosPost(body, credentials);
    if (result?.status?.code === 0) {
        return [result.status];
    }
    return result.result;
};
